import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ProcessSection from "../components/ProcessSection";

export default function Process() {
  return (
    <div>
      <Navbar />
      <ProcessSection />
      <Footer />
    </div>
  );
}